export default function SettingSelect({ label, tooltip, options, value, onChange }) {
    return (
        <div className="mb-4">
            {/* 🔹 Label */}
            <label className="font-medium flex items-center gap-2 text-gray-700 mb-1">
                {label}
                {tooltip && (
                    <span
                        title={tooltip}
                        className="text-[#8B5CF6] text-xs cursor-pointer hover:text-[#E91E63] transition"
                    >
                        ℹ️
                    </span>
                )}
            </label>

            {/* 🔹 Select Box */}
            <select
                className="w-full rounded-xl border border-[#e3e8f7] bg-white/70 backdrop-blur-sm 
        px-3 py-2 text-sm text-gray-700 placeholder-gray-400 cursor-pointer
        focus:outline-none focus:border-[#8B5CF6] focus:ring-1 focus:ring-[#8B5CF6]/40 
        transition-all duration-200 shadow-sm hover:shadow-[0_0_6px_rgba(139,92,246,0.2)]"
                value={value ?? ""}
                onChange={(e) => onChange(e.target.value)}
            >
                {options.map((o, i) => (
                    <option key={i} value={o} className="text-gray-700 bg-white">
                        {o || "None"}
                    </option>
                ))}
            </select>
        </div>
    );
}
